import ContactosService from "common/services/ContactosService"
import FormContactoPreferencias from "features/Contactos/forms/Preferencias"
import useContactoDetails from "features/Contactos/hooks/useContactoDetails"
import { useTranslation } from "react-i18next"

import { getContactoPreferenciasById } from "api/Contacto.service"
import "./styles.scss"

const Preferencias = ({ id }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { updateData, data } = useContactoDetails({
    id,
    fetch: getContactoPreferenciasById,
    update: ContactosService.updateContactoPreferencias,
  })

  return (
    <div className='px-3 contactos-preferencias'>
      <FormContactoPreferencias
        // @ts-expect-error TS(2322): Type '{ data: never[]; updateData: (payload: $TSFixMe) ...
        data={data}
        updateData={updateData}
        t={t}
      />
    </div>
  )
}

export default Preferencias
